module.exports = __webpack_public_path__ + "static/media/check.097f04a7.png";